import { configFetch as fetch } from '@laigu/utils';

export const getConversationStreamApi = ({ trackId, convId, order = 0 }) => {
  return new Promise((resolve, reject) => {
    fetch({
      url: `/conversation/${trackId}/streams/v2`,
      method: 'get',
      params: {
        conv_id: convId,
        order
      }
    })
      .then(req => {
        // 处理返回的数据
        const { data } = req;
        const { streams } = data;
        let newStreams = [];
        streams.forEach(stream => {
          newStreams = [...newStreams, ...stream];
        });
        resolve({ ...data, streams: newStreams });
      })
      .catch(e => {
        reject(e);
      });
  });
};

export const getConversationSummaryApi = convId => {
  return new Promise((resolve, reject) => {
    fetch({
      url: `/conversation/${convId}/summary`,
      method: 'get'
    })
      .then(req => {
        // 处理返回的数据
        const { data } = req;
        resolve(data);
      })
      .catch(e => {
        reject(e);
      });
  });
};

export const getConvSumConvIdsApi = ({ trackId }) => {
  return new Promise((resolve, reject) => {
    fetch({
      url: `/conversation/${trackId}/summaries_conv_list`,
      method: 'get'
    })
      .then(req => {
        const { data } = req;
        if (data && data.conv_ids) {
          resolve(data.conv_ids);
        }
        resolve([]);
      })
      .catch(e => {
        reject(e);
      });
  });
};

export const updateConvSummaryApi = ({ convId, content, tags }) => {
  return new Promise(resolve => {
    fetch({
      url: `/conversation/${convId}/summary`,
      method: 'PUT',
      data: {
        content,
        tag_ids: tags
      }
    }).then(req => {
      resolve(req);
    });
  });
};

export const createConvSummaryApi = ({ convId, content, tags }) => {
  return new Promise(resolve => {
    fetch({
      url: `/conversation/${convId}/summary`,
      method: 'post',
      data: {
        content,
        tag_ids: tags
      }
    }).then(req => {
      resolve(req);
    });
  });
};

// 新增对话标签
export const handleConvTagApi = ({ convId, tags }) => {
  return new Promise((resolve, reject) => {
    fetch({
      url: `/conversation/${convId}/tags`,
      method: 'put',
      data: {
        tag_ids: tags
      }
    })
      .then(req => {
        // 处理返回的数据
        const { data } = req;
        resolve(data);
      })
      .catch(e => {
        reject(e);
      });
  });
};

export const summaryGptApi = (convId, eventId, eventTime) => {
  return new Promise((resolve, reject) => {
    fetch({
      url: `/unified-api/conversations/v1/redirect_summary`,
      method: 'post',
      data: {
        conv_id: convId,
        event_id: eventId,
        event_time: eventTime
      }
    })
      .then(req => {
        resolve(req);
      })
      .catch(e => {
        reject(e);
      });
  });
};
